// Image navigation only. Main photos use a stable, uncropped frame.
export function attachGalleryTools(viewport) {
  if (!viewport || viewport.querySelector('[data-gallery-image-step]')) return;
  const gallery = viewport.closest('.product-gallery');
  if (!gallery) return;
  const slides = gallery.querySelectorAll('[data-gallery-slide]');
  if (!viewport.querySelector('[data-gallery-primary]') && slides.length < 2) return;
  for (const step of [-1, 1]) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'product-gallery__image-arrow';
    button.dataset.galleryImageStep = String(step);
    button.setAttribute('aria-label', step < 0 ? 'Previous image' : 'Next image');
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', step < 0 ? 'm14 5-7 7 7 7' : 'm10 5 7 7-7 7');
    svg.append(path);
    button.append(svg);
    button.addEventListener('click', () => {
      viewport.dispatchEvent(new CustomEvent('gallery:step', { bubbles: true, detail: { step } }));
    });
    viewport.append(button);
  }
}
if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-gallery-viewport]').forEach(attachGalleryTools);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-gallery-viewport]').forEach(attachGalleryTools);
  });
}
